import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <div className="bg-stone-50 min-h-[calc(100vh-96px)] flex items-center justify-center px-6 py-24">
      <SEO dynamicTitle="Siden blev ikke fundet" />
      
      <div className="max-w-md w-full text-center flex flex-col items-center gap-6">
        <div className="w-20 h-24 bg-stone-100 rounded-2xl flex items-center justify-center text-accent text-5xl shadow-sm border border-stone-200/60 relative">
          <i className="fa-solid fa-compass-slash" />
          <span className="absolute -top-2 -right-2 bg-accent text-white text-xs font-bold px-2 py-0.5 rounded-full">
            404
          </span>
        </div>
        
        <div className="flex flex-col gap-2">
          <h1 className="font-display text-3xl font-bold text-stone-900">Siden blev ikke fundet</h1>
          <p className="text-stone-500 text-sm leading-relaxed">
            Beklager, men den side du leder efter findes ikke længere, eller er blevet flyttet til en ny adresse.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row items-center gap-3 w-full mt-2">
          <Link 
            to="/" 
            className="bg-primary hover:bg-primary-light text-white font-medium py-3 px-6 rounded-md text-sm transition-all duration-300 w-full text-center hover:shadow-md"
          >
            Gå til forsiden
          </Link>
          <Link 
            to="/kontakt" 
            className="border border-stone-300 hover:border-stone-400 text-stone-700 font-medium py-3 px-6 rounded-md text-sm transition-all duration-300 w-full text-center bg-white"
          >
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  );
}
